export const A4_WIDTH_PX = 794;
export const A4_HEIGHT_PX = 1123;
export const A4_WIDTH_MM = 210;
export const A4_HEIGHT_MM = 297;

export const PDF_COLORS = {
  headerTeal: "#0F5C5A",
  headerTealLight: "#1A7A76",
  footerNavy: "#0B1A36",
  title: "#0F1B33",
  paper: "#FFFFFF",
  muted: "#4B5563",
  border: "#E5E7EB",
} as const;

export const PDF_SAFE_ZONE = {
  top: 230,
  bottom: 100,
  side: 20,
  pageNumberBottom: 32,
  pageNumberLeft: 28,
} as const;

export const PDF_CAPTURE = {
  scale: 2,
  jpegQuality: 0.92,
  settleMs: 1200,
} as const;

export const PDF_FONT_FAMILIES = ["IranYekan", "Vazirmatn", "Tahoma"] as const;
